
    import * as _0 from "../../../node_modules/react/index.js"
import * as _1 from "../../../node_modules/react-dom/index.js"
import * as _2 from "../../../node_modules/react-router/esm/react-router.js"
import * as _3 from "../../../node_modules/react-router-dom/esm/react-router-dom.js"
import * as _4 from "../../../node_modules/tslib/tslib.es6.mjs"
import { DefaultErrorInfo } from 'piral-core/lib/defaults/DefaultErrorInfo.js';
import { DefaultLoadingIndicator } from 'piral-core/lib/defaults/DefaultLoadingIndicator.js';
import { DefaultLayout } from 'piral-core/lib/defaults/DefaultLayout.js';
import { DefaultRouter } from 'piral-core/lib/defaults/DefaultRouter_v5.js';
import { DefaultRouteSwitch } from 'piral-core/lib/defaults/DefaultRouteSwitch_v5.js';
import { createRedirect, createNavigation, useCurrentNavigation } from 'piral-core/lib/defaults/navigator_v5.js'
import { integrateDebugger as originalDebugger } from "piral-core/lib/tools/debugger.js"
import { integrateEmulator } from "piral-core/lib/tools/emulator.js"
import { useGlobalStateContext } from 'piral-core/lib/hooks/globalState.js';
import { useDebugRouteFilter } from 'piral-debug-utils';
    
        export function applyStyle(element) {
          element.style.display = 'contents';
        }
      

    export function fillDependencies(deps) {
      deps['siteless']={};deps["react"]=_0;deps["react@18.3.1"]=_0;deps["react-dom"]=_1;deps["react-dom@18.3.1"]=_1;deps["react-router"]=_2;deps["react-router@5.3.4"]=_2;deps["react-router-dom"]=_3;deps["react-router-dom@5.3.4"]=_3;deps["tslib"]=_4;deps["tslib@2.8.1"]=_4
    }
  

    export { createRedirect, createNavigation };
  

    export const publicPath = "/";
  

    export function createDefaultState() {
      return {
        app: {
          error: undefined,
          loading: typeof window !== 'undefined',
          wrap: false,
        },
        components: {
          ErrorInfo: DefaultErrorInfo,
          LoadingIndicator: DefaultLoadingIndicator,
          Router: DefaultRouter,
          RouteSwitch: DefaultRouteSwitch,
          Layout: DefaultLayout,
        },
        errorComponents: {},
        registry: {
          extensions: {},
          pages: {},
          wrappers: {},
        },
        routes: {},
        data: {},
        portals: {},
        modules: [],
      };
    }
  
export function integrateDebugger(context, options, debug) { return originalDebugger(context, options, {
      defaultSettings: {},
      emulator: true,
      ...debug,
    }); }
export { integrateEmulator }

    export function useRouteFilter(paths) {
      
    useCurrentNavigation();
  
return useDebugRouteFilter(paths);
    }
  
  